// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\pages\\\\home\\\\WelcomeSection\\\\components\\\\HeroActions.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\pages\\home\\WelcomeSection\\components\\HeroActions.tsx");
  import.meta.hot.lastModified = "1757171103326.2412";
}
// REMIX HMR END

import { Link } from "@remix-run/react";
import { ArrowRight } from "lucide-react";
import { Button } from "~/components/ui/button";
export function HeroActions({
  actions
}) {
  return <div className="flex flex-col sm:flex-row items-center gap-4">
      {actions.map((action, index) => {
      if (action.onClick) {
        return <Button key={index} variant={action.variant} size="lg" className="w-full sm:w-auto" onClick={action.onClick}>
              {action.label}
              {action.icon && <ArrowRight className="h-5 w-5" />}
            </Button>;
      }
      return <Button key={index} asChild variant={action.variant} size="lg" className="w-full sm:w-auto">
            <Link to={action.href}>
              {action.label}
              {action.icon && <ArrowRight className="h-5 w-5" />}
            </Link>
          </Button>;
    })}
    </div>;
}
_c = HeroActions;
var _c;
$RefreshReg$(_c, "HeroActions");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;